import React, {Component} from 'react';
import {Link} from "react-router-dom";
import Swiper from 'react-id-swiper';




export default class Dialog extends Component {
    render() {
        const list = this.props;
        const swiperOptions = {
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
                clickable: true
            },
            autoplay:true,
            delay:4000,
            loop: true,
            spaceBetween: 30
        }
        return (
            <section>
                <div className="Lmt10">
                    <Swiper {...swiperOptions} >
                        {
                            this.props.list.map((item,index) => {
                                return <img src={item} key={index} alt=""/>
                            })
                        }

                    </Swiper>
                </div>
            </section>
        )
    }

}



// WEBPACK FOOTER //
// ./src/components/Swiper/Swiper.js